import type {StateCreator} from 'zustand'

export type DiffFilterSlice = {
  // State
  filterState: {
    filterText: string
    fileExtensions: Record<string, number>
    unselectedFileExtensions: Set<string>
    showDeletedFiles?: boolean
    showOnlyManifestFiles?: boolean
    showOnlyOwnedFiles?: boolean
    showVendoredFiles?: boolean
    showViewedFiles?: boolean
  }
  filtersInteractedWith: boolean
  // Actions
  updateFilters: (filterState: Partial<DiffFilterSlice['filterState']>, userInteracted?: boolean) => void
}

export const createDiffFilterSlice =
  (): StateCreator<DiffFilterSlice, [['zustand/devtools', never]], [], DiffFilterSlice> => (set, get) => ({
    filtersInteractedWith: false,
    filterState: {
      filterText: '',
      fileExtensions: {},
      unselectedFileExtensions: new Set(),
      showDeletedFiles: true,
      showOnlyManifestFiles: false,
      showOnlyOwnedFiles: false,
      showVendoredFiles: true,
      showViewedFiles: true,
    },
    updateFilters: (filterState: Partial<DiffFilterSlice['filterState']>, userInteracted?: boolean) => {
      set(
        {
          filtersInteractedWith: get().filtersInteractedWith || !!userInteracted,
          filterState: {
            ...get().filterState,
            ...filterState,
          },
        },
        undefined,
        'updateFilters',
      )
    },
  })
